import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'
import { clearLocalStorage } from '../../helper/storage'

export const getChatRoom = createAsyncThunk('chat/room', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/chat/chat-rooms/get-chat-room/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  chatRoomInfo: [],
  error: null
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.chat = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChatRoom.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getChatRoom.fulfilled, (state, action) => {
        state.isLoading = false
        state.chatRoomInfo = action.payload?.data?.data
      })
      .addCase(getChatRoom.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = chatSlice.actions
export default chatSlice.reducer
